// frontend/src/components/Footer.jsx
import React from "react";
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer
      id="contact"
      className="relative bg-gray-900 text-gray-300 py-20 px-6 md:px-16 overflow-hidden"
    >
      {/* Background Effects */}
      <div className="absolute -top-20 left-10 w-72 h-72 rounded-full bg-purple-700/20 blur-3xl animate-pulse-slow"></div>
      <div className="absolute -bottom-20 right-10 w-96 h-96 rounded-full bg-blue-500/20 blur-3xl animate-pulse-slow"></div>

      {/* Footer Grid */}
      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8">
        {/* Logo & Branding: col-span 4 */}
        <div className="md:col-span-4 flex flex-col items-start space-y-3">
          <img
            src="/img/logobgremo-2.png"
            alt="Portland Academy Logo"
            className="w-76 md:w-40 "
          />
          <h3 className="text-white font-bold text-2xl md:text-[20px]">
            Drive With Portland
          </h3>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed">
            Expert DVSA-approved instructors, modern training, and personalized
            lessons to build confident, safe drivers.
          </p>
        </div>

        {/* Quick Links: col-span 2 */}
        <div className="md:col-span-2 space-y-4">
          <h3 className="text-xl md:text-2xl text-white font-semibold mb-2">
            Quick Links
          </h3>
          <ul className="space-y-2 text-gray-400 text-sm md:text-base">
            <li>
              <HashLink
                smooth
                to="/"
                className="hover:text-white transition-colors duration-300"
              >
                Home
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                to="/#about"
                className="hover:text-white transition-colors duration-300"
              >
                About
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                to="/#courses"
                className="hover:text-white transition-colors duration-300"
              >
                Courses
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                to="/#areas"
                className="hover:text-white transition-colors duration-300"
              >
                Areas
              </HashLink>
            </li>


              <li>
              <HashLink
                smooth
                to="/#faq"
                className="hover:text-white transition-colors duration-300"
              >
                F&Q
              </HashLink>
            </li>
              <li>
              <HashLink
                smooth
                to="/#faq"
                className="hover:text-white transition-colors duration-300"
              >
                T&C
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                to="/#contact"
                className="hover:text-white transition-colors duration-300"
              >
                Contact
              </HashLink>
            </li>
          </ul>
        </div>

        {/* Services: col-span 2 */}
        <div className="md:col-span-2 space-y-4">
          <h3 className="text-xl md:text-2xl text-white font-semibold mb-2">
            Our Services
          </h3>
          <ul className="space-y-2 text-gray-400 text-sm md:text-base">
            <li>
              <span className="text-green-600 pr-1">✔</span> Automatic Driving
            </li>
            <li>
              <span className="text-green-600 pr-1">✔</span> Manual Driving
            </li>
            <li>
              <span className="text-green-600 pr-1">✔</span> Motorway Training
            </li>
            <li>
              <span className="text-green-600 pr-1">✔</span> Refresher Lessons
            </li>
            <li>
              <span className="text-green-600 pr-1">✔</span> Pass Plus Course
            </li>
          </ul>
        </div>

        {/* Contact & Social: col-span 4 */}
        <div className="md:col-span-4 space-y-4">
          <h3 className="text-xl md:text-2xl text-white font-semibold mb-2">
            Contact
          </h3>
          <p className="text-gray-400 text-sm md:text-base">
            Email: drivewithportland@gmail.com
          </p>
          <p className="text-gray-400 text-sm md:text-base">
            Phone: +44 7726 77 8000
          </p>

          {/* Social Icons */}
          <div className="flex gap-3 mt-4 flex-wrap">
            {/* Facebook */}
            <a
              href="https://www.facebook.com/profile.php?id=61587292087697"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 shadow-lg hover:scale-110 transition transform duration-300"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                <path d="M22 12a10 10 0 10-11.5 9.9v-7H8v-3h2.5V9a3.5 3.5 0 013.5-3.5h2v3h-2c-.3 0-.5.2-.5.5v1.5H17l-.5 3h-2V22A10 10 0 0022 12z" />
              </svg>
            </a>

            {/* YouTube */}
            <a
              href="https://www.youtube.com/@DrivewithPortland"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-red-600 shadow-lg hover:scale-110 transition transform duration-300"
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white">
                <path d="M23 7a3 3 0 00-2-2c-1.8-.5-9-.5-9-.5s-7.2 0-9 .5A3 3 0 001 7a31 31 0 000 10 3 3 0 002 2c1.8.5 9 .5 9 .5s7.2 0 9-.5a3 3 0 002-2 31 31 0 000-10zM10 15V9l6 3z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/drive_with_portland/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 shadow-lg hover:scale-110 transition transform duration-300"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
              </svg>
            </a>

            {/* Email */}
            <a
              href="mailto:drivewithportland@gmail.com"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-red-400 shadow-lg hover:scale-110 transition transform duration-300"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                <path d="M2 6c0-1.1.9-2 2-2h16a2 2 0 012 2v1l-10 6L2 7V6zm0 4l10 6 10-6v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6z" />
              </svg>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/447726778000?text=Hello%20I%20want%20to%20get%20information"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-[#25D366] shadow-lg hover:scale-110 transition transform duration-300 text-white text-lg"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-8 text-center text-gray-500 text-sm md:text-base">
        &copy; {new Date().getFullYear()} Drive With Portland. Developed by dzabsdigital.com
      </div>
    </footer>
  );
};

export default Footer;